import React from 'react';

import { getResponsiveImageAttributes } from '~/src/common/image';
import { useCurrentUser } from '~/src/common/user';
import { ContentCardMenu } from '~/src/components';

import type { Content } from '../../../types';

import { Container, ContextMenuButtonWrapper, PlayButtonWrapper, Image } from './elements';
import { PlayButton } from './PlayButton';
import { isArticleWithMedia } from '../isArticleWithMedia';

interface Props {
  content: Content;
}

export const Hero: React.FC<Props> = ({ content }) => {
  const backgroundImage = content.no_text_image.processed_url;
  const imageAttributes = getResponsiveImageAttributes(backgroundImage);
  const { isLoggedIn } = useCurrentUser();
  const isMediaArticle = isArticleWithMedia(content);

  return (
    <Container>
      {isLoggedIn && (
        <ContextMenuButtonWrapper>
          <ContentCardMenu contentId={content.id} contentTitle={content.title} />
        </ContextMenuButtonWrapper>
      )}
      {isMediaArticle && (
        <PlayButtonWrapper>
          <PlayButton content={content} />
        </PlayButtonWrapper>
      )}
      <Image {...imageAttributes} />
    </Container>
  );
};
